export const ROOT = 'quote-activity';

export const CHILD_MAIN = 'quote-activity/main';

export const CHILD_MODAL = 'quote-activity/modal';

export const MARKET = {
    US: 'US',
    HK: 'HK',
    AU: 'AU',
    MY: 'MY',
    CA: 'CA',
    JP: 'JP',
    SG: 'SG'
};

// 活动状态
export const ACTIVITY_STATUS = {
    // 活动完全未开始
    NOT_START: 1,
    // 活动进行中
    ACTIVITY_IN_PROGRESS: 2,
    // 活动已结束
    END: 3,
    // 活动预热中，但还没真正开始
    ACTIVITY_IN_PRE_PROGRESS: 4
};

// 领取接口错误码
export const RECEIVE_CODE = {
    // 活动未开始
    ACTIVITY_NOT_START: 1000,
    // 活动已结束
    ACTIVITY_END: 1001,
    // 兜底：不符合活动领取条件
    ACTIVITY_CONDITION_NOT_MATCH: 1002,
    // 已经领取过活动奖励
    ACTIVITY_PRIZES_RECEIVED: 1003,
    // 不符合领取条件，非目标主推券商
    ACTIVITY_CONDITION_NOT_MATCH_NOT_TARGET_BROKER: 1004,
    // 不符合领取条件，账户状态错误（包含未开户）
    ACTIVITY_CONDITION_NOT_MATCH_ACCOUNT_STATUS_ERR: 1005,
    // 领取活动奖励成功，待使用
    ACTIVITY_PRIZES_RECEIVED_WAIT_USE: 1006,
    // 领取活动奖励成功，已使用
    ACTIVITY_PRIZES_RECEIVED_HAVE_USED: 1007
};

export const RECEIVED_STATUS = {
    // 不符合领取条件，非目标主推券商
    NOT_THE_TARGET_BROKER: 1,
    // 不符合领取条件，未开目标券商户
    UNOPENED_ACCOUNT: 2,
    // 符合领取条件，未领取
    UNRECEIVED: 3,
    // 已领取
    RECEIVED: 4,
    // 已领取，待使用
    RECEIVED_WAIT_USE: 6,
    // 已领取，已使用
    RECEIVED_HAVE_USED: 7
};

// 用于主模块显示时机
export const MAIN_STATUS = {
    // 未领取 => RECEIVED_STATUS 1/2/3
    UNRECEIVED: 0,
    // 已领取 => RECEIVED_STATUS 4/6/7
    RECEIVED: 1
};

export const RECEIVED_STATUS_ARR = [
    RECEIVED_STATUS.RECEIVED,
    RECEIVED_STATUS.RECEIVED_WAIT_USE,
    RECEIVED_STATUS.RECEIVED_HAVE_USED
];

export const REPORT_NAME = {
    // 主模块曝光
    MAIN_VIEW: 'ExposureNsqdClaimBtn',
    // 主模块点击
    MAIN_CLICK: 'ClickNsqdClaimBtn',

    // 弹窗曝光
    MODAL_VIEW_TYPE: {
        // 领取成功，等到5.1可使用
        [RECEIVE_CODE.ACTIVITY_PRIZES_RECEIVED_WAIT_USE]: 'PopClaimSuccess1',
        // 领取成功立即使用
        [RECEIVE_CODE.ACTIVITY_PRIZES_RECEIVED_HAVE_USED]: 'PopClaimSuccess2',
        // 活动未开始
        [RECEIVE_CODE.ACTIVITY_NOT_START]: 'PopClaimFail0',
        // 活动已结束
        [RECEIVE_CODE.ACTIVITY_END]: 'PopClaimFail1',
        // 用户已参加活动
        [RECEIVE_CODE.ACTIVITY_PRIZES_RECEIVED]: 'PopClaimFail2',
        // 主推券商不符合活动规则
        [RECEIVE_CODE.ACTIVITY_CONDITION_NOT_MATCH_NOT_TARGET_BROKER]: 'PopClaimFail3',
        // 用户未注册
        [RECEIVE_CODE.ACTIVITY_CONDITION_NOT_MATCH_ACCOUNT_STATUS_ERR]: 'PopClaimFail4'
    },

    // 弹窗点击
    MODAL_CLICK_TYPE: {
        // 领取成功，等到5.1可使用
        [RECEIVE_CODE.ACTIVITY_PRIZES_RECEIVED_WAIT_USE]: 'ClickClaimSuccess1',
        // 领取成功立即使用
        [RECEIVE_CODE.ACTIVITY_PRIZES_RECEIVED_HAVE_USED]: 'ClickClaimSuccess2',
        // 活动未开始
        [RECEIVE_CODE.ACTIVITY_NOT_START]: 'ClickClaimFail0',
        // 活动已结束
        [RECEIVE_CODE.ACTIVITY_END]: 'ClickClaimFail1',
        // 用户已参加活动
        [RECEIVE_CODE.ACTIVITY_PRIZES_RECEIVED]: 'ClickClaimFail2',
        // 主推券商不符合活动规则
        [RECEIVE_CODE.ACTIVITY_CONDITION_NOT_MATCH_NOT_TARGET_BROKER]: 'ClickClaimFail3',
        // 用户未注册
        [RECEIVE_CODE.ACTIVITY_CONDITION_NOT_MATCH_ACCOUNT_STATUS_ERR]: 'ClickClaimFail4'
    },

    // 弹窗关闭
    MODAL_CLOSE_TYPE: {
        // 领取成功，等到5.1可使用
        [RECEIVE_CODE.ACTIVITY_PRIZES_RECEIVED_WAIT_USE]: 'CloseClaimSuccess1',
        // 领取成功立即使用
        [RECEIVE_CODE.ACTIVITY_PRIZES_RECEIVED_HAVE_USED]: 'CloseClaimSuccess2',
        // 活动未开始
        [RECEIVE_CODE.ACTIVITY_NOT_START]: 'CloseClaimFail0',
        // 活动已结束
        [RECEIVE_CODE.ACTIVITY_END]: 'CloseClaimFail1',
        // 用户已参加活动
        [RECEIVE_CODE.ACTIVITY_PRIZES_RECEIVED]: 'CloseClaimFail2',
        // 主推券商不符合活动规则
        [RECEIVE_CODE.ACTIVITY_CONDITION_NOT_MATCH_NOT_TARGET_BROKER]: 'CloseClaimFail3',
        // 用户未注册
        [RECEIVE_CODE.ACTIVITY_CONDITION_NOT_MATCH_ACCOUNT_STATUS_ERR]: 'CloseClaimFail4'
    }
};
